// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"Story_mainPage__2X83q","pageHeader":"Story_pageHeader__1W5ij","mainContent":"Story_mainContent__3ME22","textContent":"Story_textContent__2rgfD"};